export default __webpack_public_path__ + "static/media/hospital-seleccionado.62cf0c37.svg";